import * as classNames from 'classnames';
import { Property } from 'csstype';
import * as React from 'react';

// export const Breakpoint = {
//   GREAT: 'gt' as const,
//   HUGE: 'hg' as const,
//   LARGE: 'lg' as const,
//   MEDIUM: 'md' as const,
//   MICRO: 'mc' as const,
//   SMALL: 'sm' as const,
//   TINY: 'tn' as const,
// };
// export const Breakpoint = {
//   GREAT: 'gt',
//   HUGE: 'hg',
//   LARGE: 'lg',
//   MEDIUM: 'md',
//   MICRO: 'mc',
//   SMALL: 'sm',
//   TINY: 'tn',
// };
// export type Breakpoint = typeof Breakpoint[keyof typeof Breakpoint];
//
// interface IFrowBreakpointGutters {
//   [breakpoint: Breakpoint]: number;
// }

interface IFrowProps {
  alignItems?: Property.AlignItems;
  justifyContent?: Property.JustifyContent;
  children: React.ReactNode;
  gutters?: number;
}

export function Frow({ alignItems, children, gutters, justifyContent }: IFrowProps) {
  const classes = classNames(
    'frow',
    { [gutterClasses(gutters)]: gutters },
    { [alignItemsClasses(alignItems)]: alignItems },
    { [justifyContentClasses(justifyContent)]: justifyContent },
  );

  return <div className={classes}>{children}</div>;
}

function gutterClasses(gutters: number): string {
  return classNames(`frow--gutters-${gutters}`);
}

function alignItemsClasses(alignItems: Property.AlignItems): string {
  return classNames(`frow--align-items-${alignItems}`);
}

function justifyContentClasses(justifyContent: Property.JustifyContent): string {
  return classNames(`frow--justify-content-${justifyContent}`);
}
